import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { TrendingUp, Save, Loader2 } from 'lucide-react';
import { AdminPageHeader, API } from './_P1Common';
import { useAdmin } from '@/hooks/useAdmin';

const FIELDS = [
  { key: 'adsense_enabled', label: 'AdSense aktivan', type: 'checkbox' },
  { key: 'affiliate_enabled', label: 'Affiliate aktivan', type: 'checkbox' },
  { key: 'donation_enabled', label: 'Donacije aktivne', type: 'checkbox' },
  { key: 'micropayments_enabled', label: 'Mikroplaćanja aktivna', type: 'checkbox' },
  { key: 'min_donation_eur', label: 'Minimalna donacija (EUR)', type: 'number' },
];

export default function AdminMonetization() {
  const { authFetch } = useAdmin();
  const [data, setData] = useState(null);

  useEffect(() => {
    authFetch(`${API}/admin/monetization`).then(r => r.json()).then(setData);
  }, [authFetch]);

  const save = async () => {
    const r = await authFetch(`${API}/admin/monetization`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
    });
    if (r.ok) toast.success('Spremljeno');
  };

  if (!data) return <AdminPageHeader icon={TrendingUp} title="Monetizacija"><Loader2 className="animate-spin"/></AdminPageHeader>;

  return (
    <div data-testid="admin-monetization">
      <AdminPageHeader icon={TrendingUp} title="Monetizacija" subtitle="Globalno uključenje izvora prihoda">
        <button onClick={save} data-testid="monetize-save"
                className="inline-flex items-center gap-1 px-3 py-2 rounded bg-red-600 hover:bg-red-700 text-white text-sm font-bold">
          <Save size={14}/> Spremi
        </button>
      </AdminPageHeader>
      <div className="px-4 md:px-6 max-w-xl space-y-3">
        {FIELDS.map(f => (
          <div key={f.key} className="flex items-center justify-between gap-3 py-2 border-b border-zinc-800">
            <label className="text-sm">{f.label}</label>
            {f.type === 'checkbox' ? (
              <input type="checkbox" checked={!!data[f.key]} data-testid={`monetize-${f.key}`}
                     onChange={(e) => setData({ ...data, [f.key]: e.target.checked })}/>
            ) : (
              <input type="number" value={data[f.key] ?? 0} data-testid={`monetize-${f.key}`}
                     onChange={(e) => setData({ ...data, [f.key]: Number(e.target.value) })}
                     className="bg-zinc-900 border border-zinc-800 rounded px-3 py-2 text-sm w-32"/>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
